import { InputModalityDetector } from '@angular/cdk/a11y';
import { Component, EventEmitter, OnInit, Output, Input, inject, DestroyRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.scss'],
    standalone: false
})
export class SearchFilterComponent implements OnInit {

  @Input() placeholder = 'SEARCH.PLACE_HOLDER';
  @Output() changed = new EventEmitter();
  searchFilter: Subject<string> = new Subject<string>();
  private destroyRef = inject(DestroyRef);
  constructor() {
    this.searchFilter.pipe(
      debounceTime(500),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(search =>
      this.changed.emit(search)
    );
  }

  ngOnInit(): void {
  }

  onKeyUp(text): void {
    this.searchFilter.next(text.target.value);
  }
}
